export default [
  {
    title: "Minha Claro Móvel",
    description: "Conheça as facilidades no App Minha Claro",
    logo: "https://mondrian.claro.com.br/brands/vertical/inverse/minha-claro.svg",
    href: "https://minhaclaro.claro.com.br",
    id: "shortcut_minha_claro",
  },
  {
    title: "Claro tv+",
    description: "Assista seus conteúdos quando e onde quiser",
    logo: "https://mondrian.claro.com.br/brands/vertical/inverse/claro-tvmais.svg",
    href: "https://www.clarotvmais.com.br/home-landing",
    id: "shortcut_claro_tvmais",
  },
  {
    title: "Claro Wifi",
    description: "Acesse grátis os pontos de internet",
    logo: "https://mondrian.claro.com.br/brands/vertical/inverse/claro-wifi.svg",
    href: "https://www.claro.com.br/internet/rede-net-claro-wifi",
    id: "shortcut_wifi",
  },
  {
    title: "Claro Pay",
    description: "Os melhores planos para o seu combo",
    logo: "https://mondrian.claro.com.br/brands/vertical/inverse/claro-pay.svg",
    href: "https://www.claropay.com.br/",
    id: "shortcut_play",
  },
];
